/**
 * StepButton - 前日/翌日・前月/翌月など1ステップ移動用の矢印付きナビゲーションボタン
 *
 * スタイルは常に同一のため内部で固定している。
 * ラベルとクリックハンドラだけ渡して使う。
 *
 * @param {string}   label   - 表示テキスト (例: '◀ 前日', '翌月 ▶')
 * @param {function} onClick - クリックハンドラ
 */
function StepButton({ label, onClick }) {
  return (
    <button
      onClick={onClick}
      className="mx-2 px-3 py-2 text-lg border border-gray-400 rounded shadow-sm active:shadow-none active:translate-y-px cursor-pointer"
    >
      {label}
    </button>
  );
}

export default StepButton;
